import React from 'react';
import './App.css';
import MainComponent from './components/mainComponent';
import { Routes, Route } from 'react-router-dom';
import { ProductType } from './constants/types';
import Marktplaats from './components/marktplaatsComponent';

const App: React.FunctionComponent = () => {
  return (
    <div>
      <Main />
    </div>
  );
};

const Main = () => (
  <Routes>
    <Route path="*" element={<MainComponent firstComponent={ProductType.All} />} />
    <Route path="/" element={<MainComponent firstComponent={ProductType.All} />}></Route>
    <Route path="/Algemene Voorwaarden" element={<MainComponent firstComponent={ProductType.Cards} showText={"AlgemeneVoorwaarden"} />}></Route>
    <Route path="/Privacybeleid" element={<MainComponent firstComponent={ProductType.Cards} showText={"PrivacyBeleid"} />}></Route>
    <Route path="/Retourbeleid" element={<MainComponent firstComponent={ProductType.Cards} showText={"Retourbeleid"} />}></Route>
    <Route path="/Over Ons" element={<MainComponent firstComponent={ProductType.Cards} showText={"SiteText"} />}></Route>
    <Route path="/Pokemon Kaarten" element={<MainComponent firstComponent={ProductType.Cards} />}></Route>
    <Route path="/Pokemon Boosters" element={<MainComponent firstComponent={ProductType.Booster} />}></Route>
    <Route path="/Pokemon Collecties" element={<MainComponent firstComponent={ProductType.Collection} />}></Route>
    <Route path="/Pokemon Diverse" element={<MainComponent firstComponent={ProductType.Misc} />}></Route>
    <Route path="/Promo" element={<MainComponent firstComponent={ProductType.Promo} />}></Route>
    <Route path="/Promo2" element={<MainComponent firstComponent={ProductType.Promo2} />}></Route>
    <Route path="/Marktplaats" element={<Marktplaats />}></Route>
    <Route path="/Zoeken" element={<MainComponent firstComponent={ProductType.All} showSearch={true} />}></Route>
    <Route path="/Pokemon Kaarten/*" element={<MainComponent firstComponent={ProductType.Cards} />}></Route>
    <Route path="/151 Poster Collectie" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/151" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Paradox Rift" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Paldean Fates" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Paldea Evolved Elite Trainer Box" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Paldea Evolved" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/151 Poster" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Pokemon TCG dobbelstenen" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Pokemon TCG markers" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Sleeves" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Energy bundel" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/TCG Online code bundel" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Brilliant Stars" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Brilliant Stars 3 booster blister" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Paldean Fates Elite Trainer Box" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Paldean Fates Booster Bundle" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
    <Route path="/Pokemon kaart/*" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
  </Routes>
);

export default App;
